import { render, staticRenderFns } from "./forgot-email.vue?vue&type=template&id=8ad07d0e&scoped=true"
import script from "./forgot-email.vue?vue&type=script&lang=js"
export * from "./forgot-email.vue?vue&type=script&lang=js"
import style0 from "./forgot-email.vue?vue&type=style&index=0&id=8ad07d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad07d0e",
  null
  
)

export default component.exports